<template>
    <el-table
        :data="list" 
        border 
        :max-height="table_height"
        :header-cell-style="{background: '#f3faff'}"
        :row-key="getAreaRowKey"
        lazy
        :load="loadArea"
        :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
        show-summary
    >
        <el-table-column prop="name" label="地区" width="180" expand></el-table-column>
        <el-table-column prop="count_num" label="客户总数"></el-table-column>
        <el-table-column prop="formal_customer_num" label="成交客户数"></el-table-column>
        <el-table-column prop="formal_order_num" label="成交订单数"></el-table-column>
        <el-table-column prop="total_amount" label="销售额"></el-table-column>
        <el-table-column prop="year_svg_price" label="年均价"></el-table-column>
    </el-table>
</template>
  
<script>
import CustomerCount from "~/services/CustomerCount";

export default {
    props:{
        params:{
            type: Object,
            required: true,
        },
        table_height:{
            type: String,
            default: '585px',
        }
    },
    data() {
        return {
            loading: false,
            list: [],
        };
    },
    created(){
        let params = _.clone(this.params);
        this.getList(params);
    },
    mounted() {
        
    },
    methods: {
        getAreaRowKey(row) {
            const level = Number(row.level) || 0;
            let areaId = row.id;
            if (!areaId) {
                if (level === 1) {
                    areaId = row.province_id;
                } else if (level === 2) {
                    areaId = row.city_id;
                } else if (level === 3) {
                    areaId = row.district_id;
                }
            }

            if (areaId) {
                return [level, areaId].join('-');
            }

            return [
                'unknown',
                row.province_id || 0,
                row.city_id || 0,
                row.district_id || 0,
            ].join('-');
        },
        //客户数量概览
        getList(params) {
            // loading 动画
            this.loading = true;
            // params.order_type = 4;
            CustomerCount.getCount(params, 'finish-area')
            .then((res) => {
                if (res.code == 0) {
                    this.list = res.data;
                }
                this.loading = false;
            }).catch((err) => {
                console.error(err);
                this.loading = false;
            });
        },

        loadArea(tree, treeNode, resolve){
            // console.log(tree, treeNode, resolve);
            let params = _.clone(this.params);
            // params.order_type = 4;
            _.each(params, (val, key) => {
                // 如果值是假值，除了数字 0 和字符串 '0'，都删除该键
                if (val === undefined || val === null || (typeof val === 'string' && val === '')) {
                    delete params[key];
                }
            })
            if(tree.level == 1){
                params.province_id = tree.province_id;
            }else if(tree.level == 2){
                params.city_id = tree.city_id;
            }
            CustomerCount.getCount(params, 'finish-area')
            .then((res) => {
                if (res.code == 0) {
                    resolve(res.data)
                }
            })
            .catch((err) => {
                console.error(err);
            });
        },
        
        getSummaries(param) {
            const { columns, data } = param;
            const sums = [];
            columns.forEach((column, index) => {
                // 第一列不计算合计，显示自定义的文字内容
                if (index === 0) {
                sums.push('合计：');
                return;
                }
                // 初始化合计值为0
                let sum = 0;
                // 遍历数据，累加顶级行的值
                data.forEach(item => {
                // 累加当前项的值，注意转换为数字
                sum += Number(item[column.property]);
                });
                // 如果所有值都是数字，则显示合计结果，否则显示'-'
                if (!isNaN(sum)) {
                sums.push(Math.round(sum * 100) / 100); // 保留两位小数
                } else {
                sums.push('--');
                }
            });
            return sums
        }
    },
};
</script>
  
<style>
/* 在这里添加样式 */
</style>



// WEBPACK FOOTER //
// src/views/count/customer/area.vue